import { PaymentMethod } from 'ha/services/apiV2/types/PaymentMethod';
import { MakeCall } from 'ha/services/apiV2/createMakeCall';
import { APIV2_URL } from './constants';

interface Payload {
  paymentProvider: string;
  authToken: string;
  billingCountryCode: string;
}
export default (makeCall: MakeCall) =>
  (
    userId: number,
    { paymentProvider, authToken, billingCountryCode }: Payload,
  ) =>
    makeCall<PaymentMethod>(
      'POST',
      `${APIV2_URL}/user/${userId}/payment-method`,
      {
        data: {
          paymentProvider,
          authToken,
          billingCountryCode,
        },
      },
    );
